var exports = {
  "k": "x61f99309--c0f6b5--container",
};

module.exports = exports;
